// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4eaa88b8","239":"3c4d772d","453":"71177a2e","732":"637e4178"}[chunkId] + ".chunk.js";
};